module.exports = __webpack_public_path__ + "static/media/sunday_times_cropped.da4974d5.webp";